import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
import { useAuth0 } from '@auth0/auth0-react';
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Imports for main window --------s
import YesNoPopup from '../popup_windows/YesNoPopup';
import InfoPopup from '../popup_windows/InfoPopup';
import ObjectiveTableEditorCycle from './ObjectiveTableEditorCycle';
import SubobjectiveTableValidation from './SubobjectiveTableValidation';
import ObjectiveTableValidation from './ObjectiveTableValidation';
import PlotSubobjective from './PlotSubobjective';
import ScoringWeightsTableEditor from './ScoringWeightsTableEditor'
import UserSessionContext from '../user_session/context_user_session';
import SelectOptionPopup from '../popup_windows/SelectOptionPopup';

import { useContext, useState, useEffect } from 'react';

function ObjectiveEditorCycle(props) {
    const { user } = useAuth0();
    const usr_session_ctx = useContext(UserSessionContext);

    const [showPopup, setShowPopup] = useState(false);
    const [modifications, setModifications] = useState(false);
    const [showNoModificationDetected, setShowNoModificationDetected] = useState(false)
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
    const [showCreateSuccess, setShowCreateSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    
    // ------------------ General Window Layout -----------------------------

    const[objectives, setObjectives] = useState([]);
    const[scoringType, setScoringType] = useState('');
    const[title, setTitle] = useState('');
    const [triggerSave, setTriggerSave] = useState(0)

    // ------------------ Display Object Validation Information/Warnings/Errors  ---------------------------------
    const [validatedResponses, setValidatedResponses] = useState([]);
    const [unvalidatedChanges, setUnvalidatedChanges] = useState([]);
    const [validationWindow, setValidationWindow] = useState(false);
    const [validationMessage, setValidationMessage] = useState([]);
    const [validated, setValidated] = useState(true);
    const [confirmValidPopup, setConfirmValidPopup] = useState(false);
    const [activeObjectiveValidation, setActiveObjectiveValidation] = useState(false)
    const [showValidationSuccess, setShowValidationSuccess] = useState({success: false, subobjective: ''});
    const [validationCSV, setValidationCSV] = useState({show:false, msg:''})
    const [objectiveValidationWindow, setObjectiveValidationWindow] = useState(false);
    const [objectiveValidationMessage, setObjectiveValidationMessage] = useState([]);

    // ---- states to handel user input, including entering WorkflowEditor
    const segmentTemplateDiscrete = {type:'Discrete', min:'', max:'', val:'', list_vals:[]}
    const segmentTemplateContinuous = {type:'Interval', min:'', max:'', val:'', list_vals:[]}
    const segmentTemplateTier = {type:'Interval', min:'', max:'', val:'', list_vals:[]}
    // --- states do handle plots of subobjectives
    const [svgUrlsPlots, setSvgUrlsPlots] = useState([])

    const [uuidObjective, setUuidObjective] = useState('');
    const [showPopupApplyAllCycles, setShowPopupApplyAllCycles] = useState(false)


    // Clean up Blob URLs for plotting the subobjectives on unmounting the component
    // This also has the effect that on Enter Workflow Editor all images will be lost.
    useEffect(() => {
        return () => {
            // Clean up the Blob URL when the component unmounts
            svgUrlsPlots.forEach((svg_url, id) => {
                if(svg_url !== '') {
                    URL.revokeObjectURL(svg_url);
                }
            });
        };
    }, []);

    // useEffect( () => {
    //     if(typeof props.validated !== 'undefined'){ setValidated(props.validated); }
    //     else { setValidated(false); }
    //     }, []);


    /// ----- API Calls Backend ----------
    // Load Objectives
    useEffect( () => {
        if (props.campaign_objects.uuid_objective !== '') {
            setUuidObjective(props.campaign_objects.uuid_objective)
            const fetchObjective = async () => {
                    setIsLoading(true);
                    const uuid_objective = props.campaign_objects.uuid_objective;
                try {
                    const response = await fetch(`${SERVER_URL}/current_project/load_objective/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'uuid_tenant': usr_session_ctx.uuid_tenant
                        },
                        body: JSON.stringify(uuid_objective),
                    });
        
                    if (!response.ok) {
                        throw new Error(`HTTP error ${response.status}`);
                    }
        
                    const data = await response.json();
                    let modified = [];
                    for (let i=0; i< data.data.objectives.length; i++){
                        modified.push(false);
                    }
                    setUnvalidatedChanges(modified);
                    const valid_responses = await initial_validation_responses(data.data.objectives);
                    const urls_plots = await initialize_plots(valid_responses, data.data.objectives);
                    setValidatedResponses(valid_responses);
                    setSvgUrlsPlots(urls_plots);
                    setObjectives(data.data.objectives);
                    setTitle(data.data.title);
                    setScoringType(data.data.scoring_type);
                } catch (err) {
                    setException(true);
                    setExceptionMessage(`HTTPException: err_msg=${err.message}`);
                } 
            };
            fetchObjective();
            setIsLoading(false);
        }
    }, [props.campaign_objects.uuid_objective]);


    async function initial_validation_responses(data_objectives) {
        setIsLoading(true);
        let is_valid = []
        try{
            let headers = {
                'Content-Type': 'application/json'
            };
            const response = await fetch(`${SERVER_URL}/current_project/initial_validation_all_subobjectives/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_objectives)
            });
            if(response.ok){
                const data = await response.json();
                is_valid = data.data;
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        }
        catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
        return is_valid;
    }

    // Plot SubObjective
    async function initialize_plots(valid_objectives, data_objectives){
        setIsLoading(true);
        let urls_plots = data_objectives.map( () => ('') );
        try{
            let objectives = {is_valid: valid_objectives, data_objectives: data_objectives}
            let headers = {
                'Content-Type': 'application/json',
            };
            const response = await fetch(`${SERVER_URL}/current_project/plot_all_subobjectives/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(objectives)
            });
            if(response.ok){
                const data = await response.json();
                const svg_plots = data.data;
                svg_plots.forEach((svg_plot, id) => {
                    if(svg_plot !== ''){
                        const blob = new Blob([svg_plot], { type: 'image/svg+xml' });
                        const svg_url = URL.createObjectURL(blob);
                        urls_plots[id] = svg_url;
                    }
                });
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
        }
        catch(err) {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
        setIsLoading(false);
        return urls_plots;
    }



// ------------ Functions to Handle Save Experimental Setup --------------------------
    async function handleSave() {
        if (modifications === false && validated) {
            setShowNoModificationDetected(true);
            return;
        }
        if (props.cycleId === 0) {
            // if first cycle we can just save modifications of DesignSpace objects
            await saveObjective()
        }
        if (props.cycleId > 0) {
            // if there are previous cycles, we let the user decide if the modfication are save to be applied to globally to all cycles that are based 
            // on the design space, or if a new object DesignSpace should be crated for this cycle and potnetially following cycles
            if(props.campaign_objects_prevcycle.uuid_objective === props.campaign_objects.uuid_objective){
                setShowPopupApplyAllCycles(true);
            }
            else{
                // if we update a workflow again for the same cycle there is not reason to re-create the DesignSpace object that was not used yet
                await saveObjective()
            }
        }
    }

    async function apply2AllPrevCycles(){
        await saveObjective();
        setShowPopupApplyAllCycles(false);
    }

    async function saveAsNew(){
        await saveObjectiveAsNew();
        setShowPopupApplyAllCycles(false);
    }

    // Save Objectives
    async function saveObjective(){
        setActiveObjectiveValidation(true);
        const valid = validateObjective();
        if (!valid) {
            return;
        }
        setIsLoading(true);
        try{
            let data_objective = { uuid_project: usr_session_ctx.session_info.uuid_current_project,
                                   uuid_opt_campaign: props.uuid_opt_campaign,
                                   title: title, 
                                   objectives: objectives, 
                                   scoring_type: scoringType,
                                   uuid_objective: props.campaign_objects.uuid_objective};
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_objective/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_objective)
            });
            if(response.ok){
                await response.json();
                setModifications(false);
                setShowNoModificationDetected(false);
                setActiveObjectiveValidation(false);
                setShowUpdateSuccess(true);
                setValidated(true);
                if (props.handleSessionUpdate ){ 
                    props.handleSessionUpdate(props.campaign_objects);
                 }
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }


    // Save Objectives
    async function saveObjectiveAsNew(){
        setActiveObjectiveValidation(true);
        const valid = validateObjective();
        if (!valid) {
            return;
        }
        setIsLoading(true);
        try{
            let data_objective = { title: title, 
                                   objectives: objectives, 
                                   scoring_type: scoringType};


            let update = {
                          uuid_objective: uuidObjective,
                          uuid_opt_campaign: props.uuid_opt_campaign,
                          cycle_id: props.cycleId,
                          uuid_project: usr_session_ctx.session_info.uuid_current_project,
                          objective: data_objective
                        }
            let headers = {
                'Content-Type': 'application/json',
                'auth0_user': user.sub,
                'uuid_tenant': usr_session_ctx.uuid_tenant
            };
            const response = await fetch(`${SERVER_URL}/current_opt_campaign/update_objective_as_new/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(update)
            });
            if(response.ok){
                const data = await response.json();
                setModifications(false);
                setShowNoModificationDetected(false);
                setActiveObjectiveValidation(false);
                setShowCreateSuccess(true);
                setValidated(true);
                setUuidObjective(data.data)
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }
    
    // Validate SubObjective
    async function validateSubObjetive(objective_id){
        setIsLoading(true);
        try{
            let data_objective = objectives[objective_id];
            let headers = {
                'Content-Type': 'application/json',
            };
            const response = await fetch(`${SERVER_URL}/current_project/validate_subobjective/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_objective)
            });
            if(response.ok){
                const data = await response.json();
                if(data.msg.status === 'ok'){
                    // FIXME OPEN POUP THAT ALL WAS OKAY
                    // => something like this setShowUpdateSuccess(true);
                    setValidationWindow(false);
                    setValidationMessage({});
                    // If we are in ObjectiveValidationMode -> remove previous error message is validation was sucessful
                    if(objectiveValidationMessage.unvalidated){
                        let updatedObjectiveValidationMessage = {...objectiveValidationMessage};
                        updatedObjectiveValidationMessage.unvalidated = updatedObjectiveValidationMessage.unvalidated.filter(item => item.objective_id !== parseInt(objective_id));
                        setObjectiveValidationMessage(updatedObjectiveValidationMessage);
                        setTriggerSave(triggerSave+1);
                    }
                    if(objectives[objective_id].is_score){
                        plotSubObjective(objective_id);
                    }
                    setShowValidationSuccess({success: true, subobjective: objectives[objective_id].name})
                    let updatedValidatedResponses = [...validatedResponses];
                    updatedValidatedResponses[objective_id] = true;
                    setValidatedResponses(updatedValidatedResponses);
                    let updatedUnvalidatedChanges = [...unvalidatedChanges];
                    updatedUnvalidatedChanges[objective_id] = false
                    setUnvalidatedChanges(updatedUnvalidatedChanges);
                    // updeate internal state to valide all Objectives -> this is relevant for error validation onHandleSave
                    if (activeObjectiveValidation){
                        validateObjective();
                        // setTriggerSave(triggerSave + 1);
                        setActiveObjectiveValidation(false);
                    }
                    
                }
                else {
                    setValidationMessage({objective_id: objective_id, 'msg': data.msg})
                    setValidationWindow(true)
                }
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);

        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }

    }










    // Plot SubObjective
    async function plotSubObjective(objective_id){
        setIsLoading(true);
        try{
            let data_objective = objectives[objective_id];
            let headers = {
                'Content-Type': 'application/json'
            };
            const response = await fetch(`${SERVER_URL}/current_project/plot_submitted_subobjective/`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(data_objective)
            });
            if(response.ok){
                const data = await response.json();
                const svg_plot = data.data;
                const blob = new Blob([svg_plot], { type: 'image/svg+xml' });
                const svg_url = URL.createObjectURL(blob)
                let updatedSvgUrlsPlots = [...svgUrlsPlots];
                let prev_svg_url = updatedSvgUrlsPlots[objective_id];
                if (prev_svg_url !== ''){
                    URL.revokeObjectURL(prev_svg_url);
                }
                updatedSvgUrlsPlots[objective_id] = svg_url;
                setSvgUrlsPlots(updatedSvgUrlsPlots);
            }
            if(!response.ok){
                throw new Error(`HTTP error ${response.status}`);
            }
            setIsLoading(false);

        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }

    }


    ///  ---- Functions to handle Popup Windows -------------------------
    function onOkNoModifications(){
        setShowNoModificationDetected(false);
    }
    function onOkUpdate(){
        setShowUpdateSuccess(false);
        setObjectiveValidationMessage([]);
    }
    function onOkValidation(){
        setShowValidationSuccess({success: false, subobjective: ''});
    }
    function onOkCreate(){
        setShowCreateSuccess(false);
    }

    function handleExit(event){
        if(modifications===true) {
            setShowPopup(true);
        }
        else{
            props.exit();
        }
    }

    function onYes(){
        props.exit();
    }
    function onNo(){
        setShowPopup(false);
    }


    function handleConfirmValid(){
        const valid = validateObjective()
        if (valid){
            setValidated(true);
            setConfirmValidPopup(true);
            if (props.handleSessionUpdate ){ 
                    props.handleSessionUpdate(props.campaign_objects);
            }
            setTriggerSave(triggerSave+1);
        }
    }


    function onOkconfirmValidPopup(){
        setConfirmValidPopup(false);
    }


    ///  ---- Handle User Input  -------------------------
    function handleTitle(event){
        setTitle(event.target.value);
        setModifications(true);
    }


    function handleScore(event){
        let parser = event.target.id.split('_');
        let objective_id = parseInt(parser[2]);
        let key = parser[0]+'_'+parser[1];
        let value = event.target.checked;
        const updatedObjectives = [...objectives];
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: value };
        if (value === false ) {
            // re-set target, okay and no_good to []
            updatedObjectives[objective_id].target = [];
            updatedObjectives[objective_id].okay = [];
            updatedObjectives[objective_id].no_good = [];
            if(updatedObjectives[objective_id].type === 'Continuous' && !updatedObjectives[objective_id].go_nogo){ updatedObjectives[objective_id].range_continuous = JSON.parse(JSON.stringify(segmentTemplateContinuous)) }
            if(updatedObjectives[objective_id].type === 'Discrete' && !updatedObjectives[objective_id].go_nogo){ updatedObjectives[objective_id].range_discrete = JSON.parse(JSON.stringify(segmentTemplateDiscrete)) }
            updatedObjectives[objective_id].no_good = [];
        }
        setObjectives(updatedObjectives);

        setModifications(true);
        if (value === false){
            // reset svgUrls 
            let updatedSvgUrlsPlots = [...svgUrlsPlots];
            updatedSvgUrlsPlots[objective_id] = '';
            setSvgUrlsPlots(updatedSvgUrlsPlots);
        }

        if (value === false && !updatedObjectives[objective_id].go_nogo) {
            // Reset validation 
            let updatedUnvalidatedChanges = [...unvalidatedChanges];
            updatedUnvalidatedChanges[objective_id] = false
            setUnvalidatedChanges(updatedUnvalidatedChanges);
            let updatedValidatedResponses = [...validatedResponses];
            updatedValidatedResponses[objective_id] = true;
            setValidatedResponses(updatedValidatedResponses);
        }
        else {
            let updatedUnvalidatedChanges = [...unvalidatedChanges];
            updatedUnvalidatedChanges[objective_id] = true
            setUnvalidatedChanges(updatedUnvalidatedChanges);
            let updatedValidatedResponses = [...validatedResponses];
            updatedValidatedResponses[objective_id] = false;
            setValidatedResponses(updatedValidatedResponses);
        }
    }

    function handleType(event){
        let parser = event.target.id.split('_');
        let objective_id = parseInt(parser[1]);
        let key = parser[0];
        let value = event.target.value;
        let previous_type = objectives[objective_id].type
        const updatedObjectives = [...objectives];
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: value };
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], target: []};
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], okay: []};
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], no_good: []};
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], go_criteria: []};
        if (previous_type === 'Discrete'){
            updatedObjectives[objective_id] = {...updatedObjectives[objective_id], range_discrete: JSON.parse(JSON.stringify(segmentTemplateDiscrete))};
        }
        if (previous_type === 'Continuous'){
            updatedObjectives[objective_id] = {...updatedObjectives[objective_id], range_continuous: JSON.parse(JSON.stringify(segmentTemplateContinuous))};
        }
        setObjectives(updatedObjectives);
        setModifications(true);
        let updatedUnvalidatedChanges = [...unvalidatedChanges];
        updatedUnvalidatedChanges[objective_id] = true
        setUnvalidatedChanges(updatedUnvalidatedChanges);
        let updatedValidatedResponses = [...validatedResponses];
        updatedValidatedResponses[objective_id] = false;
        setValidatedResponses(updatedValidatedResponses);
    }

    function handleUnits(event){
        let parser = event.target.id.split('_');
        let objective_id = parseInt(parser[1]);
        let key = parser[0];
        let value = event.target.value;
        const updatedObjectives = [...objectives];
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: value };
        setObjectives(updatedObjectives);
        setModifications(true);
    }

    function handleRemarks(event){
        let parser = event.target.id.split('_');
        let objective_id = parser[1];
        let key = parser[0];
        let value = event.target.value;
        const updatedObjectives = [...objectives];
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: value };
        setObjectives(updatedObjectives);
        setModifications(true);
    }

    function handleRange(event){
        let parser = event.target.id.split('_');
        let objective_id = parseInt(parser[3]);
        // let key = parser[0]+'_'+parser[1]; // this gives range_continuous
        let key_field = parser[2]; // this gives min or max
        let value = event.target.value;

        const updatedObjectives = [...objectives];
        let updatedRangeContinuous = {...updatedObjectives[objective_id].range_continuous};
        updatedRangeContinuous[key_field] = value;
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], range_continuous: updatedRangeContinuous };
        setObjectives(updatedObjectives);
        setModifications(true);
        let updatedUnvalidatedChanges = [...unvalidatedChanges];
        updatedUnvalidatedChanges[objective_id] = true
        setUnvalidatedChanges(updatedUnvalidatedChanges);
        let updatedValidatedResponses = [...validatedResponses];
        updatedValidatedResponses[objective_id] = false;
        setValidatedResponses(updatedValidatedResponses);
    }

    function handleRankingTiers(event){
        let parser = event.target.id.split('_');
        let tier = parser[0] // gives target, okay, or nogood
        if (tier === 'nogood') { tier = 'no_good';}
        if (tier === 'gocriteria') { tier = 'go_criteria';}
        const field_key = parser[1]
        const objective_id = parseInt(parser[2])
        const segment_id = parseInt(parser[3])
        // if tier is not yet initialize, any first action in the input mask will trigger initialization with segmentTemplateTier
        const updatedObjectives = [...objectives];

        if(field_key === 'add'){
            updatedObjectives[objective_id][tier].push(JSON.parse(JSON.stringify(segmentTemplateTier)));
        }

        else if(field_key === 'remove'){
            updatedObjectives[objective_id][tier] = updatedObjectives[objective_id][tier].filter((_, index) => index !== segment_id);
        }

        else if(field_key === 'type'){
            let new_type = event.target.value;
            updatedObjectives[objective_id][tier][segment_id][field_key] = event.target.value;
            if (new_type === 'Interval'){
                updatedObjectives[objective_id][tier][segment_id].val = '';
            }
            else {
                updatedObjectives[objective_id][tier][segment_id].min = '';
                updatedObjectives[objective_id][tier][segment_id].max = '';
            }
        }

        else {
            updatedObjectives[objective_id][tier][segment_id][field_key] = event.target.value;
        }
        setObjectives(updatedObjectives);
        setModifications(true);
        let updatedUnvalidatedChanges = [...unvalidatedChanges];
        updatedUnvalidatedChanges[objective_id] = true
        setUnvalidatedChanges(updatedUnvalidatedChanges);
        let updatedValidatedResponses = [...validatedResponses];
        updatedValidatedResponses[objective_id] = false;
        setValidatedResponses(updatedValidatedResponses);
    }

    function onOkvalidationCSVInput(){
        setValidationCSV({show:false, msg:''})
    }

    function onBlurCSV(event){
        let parser = event.target.id.split('_');
        let objective_id = null;
        let key = null;
        if (parser.length === 2){
            objective_id = parser[1];
            key = parser[0];
        }
        if (parser.length === 3){
            objective_id = parser[2];
            key = parser[0]+'_'+parser[1];
        }
        let list_vals = event.target.value;
        let csv2list = list_vals.split(','); 
        let csv2listFloat = [];
        let detected_NaNs = [];
        // Clean Up CSV input
        // 1. Convert strings in range_discrete.list_vals to floats.
        csv2list.forEach((elem) => {
            // Remove all whitespace from the element and parse it as a float
            const elem2float = parseFloat(elem.replace(/\s+/g, ''));
            if (isNaN(elem2float) && elem.replace(/\s+/g, '') !== ''){ detected_NaNs.push(elem);}
            if (!isNaN(elem2float)) {csv2listFloat.push(elem2float);}
        });
        // 2. If list contains NaN -> strip and show info message to user. 
        if (detected_NaNs.length >0)
        {
            let input_field = ''
            if (key === 'range_discrete') { input_field = 'Range Discrete'; }
            if (key === 'target') { input_field = 'Target'; }
            if (key === 'okay') { input_field = 'Okay'; }
            if (key === 'no_good') { input_field = 'No-Good'; }
            if (key === 'go_criteria') { input_field = 'Go-Criteria'; }
                 
                let info_msg = (<><div style={{fontWeight:'bold'}}>Removed NaNs in CSV Input:</div>
                        <ul style={{textAlign:'left'}}> 
                            <li> Response Name: <strong>{objectives[objective_id].name}</strong></li>
                            <li> Input Field: <strong>{input_field}</strong></li>
                            <li> Removed Input: <strong>[{detected_NaNs.join(', ')}]</strong></li>
                            <li> Cleaned CSV Input: <strong>[{csv2listFloat.join(', ')}]</strong></li>
                        </ul>
                        </>);
            setValidationCSV({show:true, msg:info_msg})
        }
        const updatedObjectives = [...objectives];
        const updatedRangeDiscrete = JSON.parse(JSON.stringify(segmentTemplateDiscrete));
        updatedRangeDiscrete.list_vals = csv2listFloat;
        if (key === 'range_discrete') {
            updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: updatedRangeDiscrete };
        }
        else{
            updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: [updatedRangeDiscrete] };
        }
        setObjectives(updatedObjectives);
    }

    function handleInputCSV(event){
        let parser = event.target.id.split('_');
        let objective_id = null;
        let key = null;
        if (parser.length === 2){
            objective_id = parser[1];
            key = parser[0];
        }
        if (parser.length === 3){
            objective_id = parser[2];
            key = parser[0]+'_'+parser[1];
        }
        let list_vals = event.target.value;
        let received_NaN = false;   

        let csv2list = list_vals.split(', ')  

        for (let id = 0; id < csv2list.length; id++) {
            let elem = csv2list[id];
            // Remove all blanks (whitespace) from the input string
            elem = elem.replace(/\s+/g, '');
            const elem2float = parseFloat(elem);
            if (isNaN(elem2float) && elem !== '' && elem !== '-' && elem !== '.' && elem !== '-.') {
                received_NaN = true;
                break; 
            }
        }
        if(!received_NaN){
            const updatedObjectives = [...objectives];
            const updatedRangeDiscrete = JSON.parse(JSON.stringify(segmentTemplateDiscrete));
            updatedRangeDiscrete.list_vals = csv2list;
            if (key === 'range_discrete') {
                updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: updatedRangeDiscrete };
            }
            else{
                updatedObjectives[objective_id] = {...updatedObjectives[objective_id], [key]: [updatedRangeDiscrete] };
            }
            setObjectives(updatedObjectives);
            setModifications(true);
            let updatedUnvalidatedChanges = [...unvalidatedChanges];
            updatedUnvalidatedChanges[objective_id] = true
            setUnvalidatedChanges(updatedUnvalidatedChanges);
            let updatedValidatedResponses = [...validatedResponses];
            updatedValidatedResponses[objective_id] = false;
            setValidatedResponses(updatedValidatedResponses);
        }
    }


    // ------------- Handle Input Total Score --------------------------------------
    // 
    function handleScoringType(event){
        /// reset scoring_weights to 1 if we switch back to Multiplicative
        if(event.target.value === 'Multiplicative'){
            const updatedObjectives = objectives.map(objective => {
                return { ...objective, scoring_weight: 1 };
            });
            setObjectives(updatedObjectives)
        }
        setScoringType(event.target.value);
        setModifications(true);
    }

    function handleScoringWeights(event){
        let parser = event.target.id.split('_');
        // let key = parser[0] + '_' + parser[1];
        let objective_id = parser[2];
        const updatedObjectives = [...objectives];
        updatedObjectives[objective_id] = {...updatedObjectives[objective_id], scoring_weight: event.target.value };
        setObjectives(updatedObjectives);
        setModifications(true);
    }
    


    // ------------- Validation of Input for the Responses
    // Validates Input of a Response -> onClick 'Validate' button
    function handleValidation(event){
        let parser = event.target.id.split('_');
        let objective_id = parseInt(parser[1])
        // if event was triggered inside of 'validate_button' in <SubobjectiveTableValidation />
        const event_id = parser[0] + '_' + parser[1];
        if (event_id === 'validate_button'){
            objective_id = validationMessage.objective_id;
        }
        // if event was triggered inside <ObjectiveTableValidation />
        if (parser[0]+'_'+parser[1] === 'objective_validation'){
            objective_id = parser[2];
        }   
        validateSubObjetive(objective_id);
    }


    function handleInputValidation(event){
        let parser = event.target.id.split('_');
        let input_key = parser[0]+'_'+parser[1];
        if (input_key === 'range_continuous'){
            handleRange(event);
        }
        if (parser[0] === 'target' || 
            parser[0] === 'okay' ||  
            parser[0] === 'nogood' ||
            parser[0] === 'gocriteria')
        {
            handleRankingTiers(event)
        }
    }

    function handleExitValidation(){
        setValidationMessage([]);
        setValidationWindow(false);
        setObjectiveValidationMessage([]);
        setObjectiveValidationWindow(false);
    }


    function handleExitObjectiveValidation(){
        setObjectiveValidationMessage([]);
        setObjectiveValidationWindow(false);
        setActiveObjectiveValidation(false);
    }



    function validateObjective(){
        // check if there are unvalidated responses
        let valid = true;
        let unvalidated = []
        let invalidScoringWeight = []

        let contains_score = false;

        objectives.forEach((objective, id) => {
            
            if( objective.is_score) {
                contains_score = true 
            }
            
            if( (objective.is_score || objective.go_nogo) && !validatedResponses[id] )
                {
                    valid = false;
                    unvalidated.push({ name:objective.name, 
                                       objective_id:id,
                                       validation_error: 'unvalidated response'});
                }
        });
        // check if the Objcetive has at least 1x response marked as subscore
        if (!contains_score) {
            valid = false;
            unvalidated.push({ name: 'no sub-score found', 
                               objective_id: '',
                               validation_error: 'expect at least 1x response to be a Sub-Score'});
         }

        if (scoringType === 'Additive'){
            objectives.forEach((objective, id) => {
                let scoring_weight = objective.scoring_weight;
                // check if scoring_weight is a valid number
                scoring_weight = parseFloat(scoring_weight);
                let is_number = false;
                if (!Number.isNaN(scoring_weight)) {
                   is_number = true; 
                }
                if ( objective.is_score && !is_number )
                    {
                        valid = false;
                        invalidScoringWeight.push({ name:objective.name, 
                                                    objective_id:id,
                                                    validation_error: 'undefined scoring weight'});
                    }
            });
        }

        let err_msg = {unvalidated:unvalidated, undefined_weights:invalidScoringWeight};
        if (!valid) {
            setObjectiveValidationWindow(true);
        }
        else {
            setObjectiveValidationWindow(false);
        }
        setObjectiveValidationMessage(err_msg);
        return valid;
    }


    function handleSaveValidation(){
        setObjectiveValidationWindow(false);
        setTriggerSave(triggerSave+1);
    }

    useEffect(() => {
        // Make sure this is not called on first render
        if(triggerSave>0){
            handleSave();
        }
    }, [triggerSave])

   
    let plot_objectives = (<></>)
    if(objectives.length >0)
        {
            plot_objectives = (<PlotSubobjective svgUrls={svgUrlsPlots} 
                                plots_per_row={3}
                                objectives={objectives}
                                enable_export={false}/>);
    }



    let total_score = (<></>)
    if(scoringType === 'Multiplicative') {
        let isMultiplicative = true
        let isAdditive = false
        total_score = (<>
                    <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'5px', width:'fit-content'}} >
                        Total Score
                    </h4>
                    <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                        <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>  
                            <input type="radio" name="total_score" value="Multiplicative" checked={isMultiplicative} onChange={handleScoringType}/>
                        </div>
                        <div><strong>multiplicative: </strong> Use when a low individual sub-score should result in a low total score.</div>
                    </div>

                    <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                        <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>
                            <input type="radio" name="total_score" value="Additive" checked={isAdditive} onChange={handleScoringType} />
                        </div>
                        <div><strong>additive: </strong> Use when a low individual sub-scores can be offset by high other sub-scores.</div>
                    </div>
                </>);
    }
    if(scoringType === 'Additive') {
        let isMultiplicative = false
        let isAdditive = true
        total_score = (<>
            <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'5px', width:'fit-content'}} >
                Total Score 
            </h4>
            <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>  
                    <input type="radio" name="total_score" value="Multiplicative" checked={isMultiplicative} onChange={handleScoringType}/>
                </div>
                <div><strong>multiplicative: </strong> Use when a low individual sub-score should result in a low total score.</div>
            </div>

            <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
                <div style={{marginRight:'5px', width:'20px', height: '20px', display:'flex', justifyContent: 'center', alignItems:'center'}}>
                    <input type="radio" name="total_score" value="Additive" checked={isAdditive} onChange={handleScoringType} />
                </div>
                <div><strong>additive: </strong> Use when a low individual sub-scores can be offset by high other sub-scores.</div>
            </div>
            <div style = {{display:'flex', fontSize:'14px', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'5px', overflow:'auto', height:'fit-content', width:'95%'}}>
                <div style = {{marginLeft:'25px', fontSize:'14px'}}>
                    If applicable, prioritize sub-scores by giving them higher scoring weights in the total score (default setting: all contribute equally).
                </div>
            </div>   
            <div style = {{display:'flex', alignItems:'top', margin:'0px', marginLeft:'10px', marginBottom:'15px', overflow:'auto', height:'fit-content', width:'95%'}}>
                    <ScoringWeightsTableEditor objectives={objectives} inputHandler={handleScoringWeights}/>
            </div>  
            
        </>);

    }


    let editor = (<></>)
    if(isLoading && !Exception){
        editor = (<div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        editor = (<>
                    <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }

    let confirm_valid = <></>
        if(!validated){
            let all_valid = true; 
            validatedResponses.forEach((valid) => {
                if(!valid) { all_valid = false; }
            });
            if(all_valid) {
                confirm_valid = (<>
                            <div style={{marginLeft:'20px', marginTop:'20px', marginBottom:'10px', display:'flex', justifyItems:'center'}}>
                                <button 
                                    // className={'actionButtonTiny'}
                                    className={'tableButton'}
                                    style={{marginTop:'0px', marginLeft: '0px', marginBottom:'px'}}
                                    onClick={handleConfirmValid}
                                    >
                                    validate
                                </button>
                                <div style={{margin:'0px', padding:'0px', fontSize:'14px', color:'var(--aixelo-red)'}}>Changes in Experimental Workflow require Objective (re)validation.</div>
                            </div>
                        </>);
            }
        }



    if(!isLoading && !Exception){
        if(!showPopup){
            editor = (<>
                        <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                            <h3 style={{marginTop:'10px', marginBottom:'5px' ,marginLeft:'20px', padding:'0px', color:'var(--aixelo-red)'}}>Objective Editor <br/><span style={{fontWeight:'normal'}}>restricted to ensure compatibility throughout this optimization campaign</span></h3>
                            <div style = {{marginLeft: '20px', marginTop: '0px', marginBottom: '20px', fontSize: '12px', position: 'relative', width:'fit-content'}} >
                                Responses are derived from Experimental Workflow with uuid: {props.campaign_objects.uuid_experimental_setup}.<br/>
                            </div>
                            {confirm_valid}
                            <div style={{display:'flex'}}>
                                <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={handleSave}>Save</button>
                                <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px', width:'110px'}} onClick={handleExit}>Exit</button>
                            </div>
                            <input id='title' style = {{marginLeft:'20px', marginTop: '10px', marginBottom: '10px', border:'none', outline:'none', padding:'5px', position: 'relative',
                                                        borderLeft: '0.5px solid var(--aixelo-gray-light)', fontSize: '24px', fontWeight:'bold', width:'94%'}} 
                                            onChange = {handleTitle} value={title} autoComplete="off" type="text" placeholder="Enter Objective Function Title"  name="project_title" />
                            <div style={{width: `${props.width * 0.95 - 60}px`, marginLeft:'20px', overflow:'auto'}}>
                                <ObjectiveTableEditorCycle objectives={objectives} 
                                                      validatedResponses={validatedResponses}
                                                      inputHandlerType={handleType}
                                                      inputHandlerRange={handleRange}
                                                      inputHandlerUnits={handleUnits}
                                                      inputHandlerScore={handleScore}
                                                      inputHandlerCSV={handleInputCSV}
                                                      onBlurCSV={onBlurCSV}
                                                      inputHandlerRemarks={handleRemarks}
                                                      inputRankingTiers={handleRankingTiers}
                                                      validationHandler={handleValidation}
                                                      unvalidatedChanges={unvalidatedChanges}
                                                      />
                            </div> 
                            <div style = {{width: `${props.width * 0.95 - 60}px`, marginLeft: '20px', marginTop: '20px', marginBottom: '20px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                                {total_score}
                            </div>


                            <div style={{width: `${props.width * 0.95 - 60}px`, height:'fit-content', padding:'0px', marginLeft:'20px', marginTop:'15px', marginBottom:'30px', overflow:'auto', border:'solid 0.5px var(--aixelo-gray-light)'}}>
                                {plot_objectives}
                            </div>
                        </div>
                        
                        
                    </>
                    );
        }
        if(validationWindow) {
            let subobjective_id = validationMessage.objective_id;
            let subobjective = objectives[subobjective_id];
            let action_panel = (
                                <>
                                    <div style={{marginTop:'25px'}}>
                                        <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in Objecitve Editor.</div>
                                        <div style={{display:'flex', margin:'0px'}}>
                                            <button id='validate_button' className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleValidation}>Validate</button>
                                            <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                                        </div>
                                    </div>
                                </>
                                );
        
            let show_validations = (<>
                                        <div style={{position: 'relative', marginLeft:'20px', marginTop:'25px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                                            <SubobjectiveTableValidation subobjective={subobjective}
                                                                         subobjective_id={subobjective_id} 
                                                                         invalidFields={validationMessage.msg.err_msg_data}
                                                                         inputHandler={handleInputValidation}
                                                                         inputHandlerCSV={handleInputCSV}
                                                                         inputHandlerScore={handleScore}
                                                                         onBlurCSV={onBlurCSV}/> 
                                        </div>
                                    </>);
            editor = (<>
                        <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                            {/* <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Validation Subobjective Name: {subobjective.name}</h3> */}
                            <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Subobjective Validation</h3>
                            <div style={{marginLeft:'20px', marginBottom:'10px', padding:'0px', fontWeight:'bold'}}>Subobjective Name: {subobjective.name}</div>
                            <div style={{marginLeft:'20px', marginBottom:'0px', fontSize:'14px'}}>The following inconsistencies in the provided subobjective have been detected.</div>
                            {show_validations}
                            {action_panel}
                        </div>
                    </>);
        }
        if(objectiveValidationWindow && !validationWindow){
            let action_panel = (
                <>
                    <div style={{marginTop:'25px'}}>
                        <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in Objecitve Editor.</div>
                        <div style={{display:'flex', margin:'0px'}}>
                            <button id='validate_button' className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSaveValidation}>Save</button>
                            <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExitObjectiveValidation}>Exit</button>
                        </div>
                    </div>
                </>
                );
            let show_validations = (<>
                        <div style={{position: 'relative', marginLeft:'20px', marginTop:'25px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                            <ObjectiveTableValidation objectives={objectives}
                                                      validationMessage={objectiveValidationMessage}
                                                      handleValidation={handleValidation}
                                                      inputHandler={handleScoringWeights}
                                                      toEditor={handleExitValidation}
                                                      /> 
                        </div>        
                    </>);

            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Objective Validation</h3>
                    <div style={{marginLeft:'20px', marginBottom:'0px', fontSize:'14px'}}>The following inconsistencies in the provided objecitve have been detected.</div>
                    {show_validations}
                    {action_panel}
                </div>
            </>);

        }

        if(showPopup){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <YesNoPopup ypos={'60px'} handleYes={onYes} handleNo={onNo}>
                        Modifications detected. Exit without saving?
                    </YesNoPopup>  
                </div>
            </>);
        }
        if(confirmValidPopup){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <InfoPopup ypos={'60px'} handleOk={onOkconfirmValidPopup}>
                        Validation successfull!
                    </InfoPopup>  
                </div>
            </>);
        }


        if(showValidationSuccess.success){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <InfoPopup ypos={'60px'} handleOk={onOkValidation} >
                       <strong>{showValidationSuccess.subobjective}</strong> succesfully validated!
                    </InfoPopup>  
                </div>
            </>);
        }


        if(showUpdateSuccess && !showValidationSuccess.success){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <InfoPopup ypos={'60px'} handleOk={onOkUpdate} >
                       Successfully updated object Objective (uuid:{uuidObjective})
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showNoModificationDetected){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <InfoPopup ypos={'60px'} handleOk={onOkNoModifications} >
                       Object Objective is already up to date.
                    </InfoPopup>  
                </div>
            </>);
        }
        if(validationCSV.show){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}}>
                    <InfoPopup ypos={'60px'} handleOk={onOkvalidationCSVInput} >
                       {validationCSV.msg}
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showPopupApplyAllCycles){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <SelectOptionPopup ypos={'60px'} 
                        options = {['this cycle', 'all cycles']} 
                        actions = {[saveAsNew, apply2AllPrevCycles]}>
                        Unless there are good reasons, it is <strong>recommended to apply the modifications to only this cycle</strong> and future cycles and not to all cycles to avoid inconsistencies..
                    </SelectOptionPopup>  
                </div>
            </>);
        } 
        else if(showCreateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} style={{marginTop: '20px', height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkCreate} >
                        Successfully updated Objective as new Object:
                            <div style={{textAlign: 'left'}}>
                                <ul>
                                    <li style={{marginBottom:'5px'}}>uuid: {uuidObjective}</li>
                                </ul>
                       </div>
                    </InfoPopup>  
                </div>
            </>);
        }   
    }
    return (<>
                {editor}
            </>);
}

export default ObjectiveEditorCycle